function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.08333 13.9722C1.79467 13.9722 0.75 12.9276 0.75 11.6389V6.97222C0.75 4.03904 0.75 2.57245 1.66122 1.66122C2.57245 0.75 4.03904 0.75 6.97222 0.75H10.0833C11.372 0.75 12.4167 1.79467 12.4167 3.08333M7.74992 16.3056H10.0833C12.2831 16.3056 13.3831 16.3056 14.0665 15.6221C14.7499 14.9387 14.7499 13.8388 14.7499 11.6389V7.75C14.7499 5.55011 14.7499 4.45017 14.0665 3.76675C13.3831 3.08333 12.2831 3.08333 10.0833 3.08333H7.74992C5.55003 3.08333 4.45009 3.08333 3.76667 3.76675C3.08325 4.45017 3.08325 5.55011 3.08325 7.75V11.6389C3.08325 13.8388 3.08325 14.9387 3.76667 15.6221C4.45009 16.3056 5.55003 16.3056 7.74992 16.3056Z",
  stroke: "#A6A6A6",
  strokeWidth: 1.5
});

var SvgCopy = function SvgCopy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy.cc2d8571.svg";
export { ForwardRef as ReactComponent };